// // Support component names relative to this directory:
// var componentRequireContext = require.context("components", true);
// var ReactRailsUJS = require("react_ujs");
// ReactRailsUJS.useContext(componentRequireContext);
//
import ReactOnRails from 'react-on-rails';

import HelloWorld from '../bundles/HelloWorld/components/HelloWorld';
import Ad from '../components/adBanners/ad';
import AdsImpressionsTracker from '../components/adBanners/adsImpressionsTracker';
import AdsLoader from '../components/adBanners/adsLoader';
import Popups from '../components/flexiblePopups/show';
import SubscriptionHandler from '../components/subscriptions/handler';
import NavigationSide from '../components/navigation/side';
import NavigationSearchOverlay from '../components/navigation/searchOverlay';
import LazyInlineInput from '../components/subscriptions/lazyInlineInput';
import RelatedArticlesSidebar from '../article_components/article/sidebar/relatedLazy';
import ArticlesGrid from '../components/article/blocks/grid';
import TopNotificationLayer from '../components/topNotification/layer';

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({
    HelloWorld, Ad, AdsImpressionsTracker, AdsLoader, Popups, SubscriptionHandler, NavigationSide,
    NavigationSearchOverlay, LazyInlineInput, RelatedArticlesSidebar, ArticlesGrid, TopNotificationLayer
});
